export enum ServerStatuses {
  NOT_ALLOWED_STATUS = 403
}
